import React from 'react';
import { Link } from 'react-router-dom';

const Product = () => {
  const features = [
    {
      title: 'Interactive learning',
      description: 'Gamified missions and activities kids actually finish'
    },
    {
      title: 'Personalized paths',
      description: 'Adaptive journeys tuned to pace and confidence'
    },
    {
      title: 'Built to scale safely',
      description: 'Privacy-aware design and production-grade engineering'
    },
    {
      title: 'Progress you can see',
      description: 'Analytics and streaks parents and educators trust'
    }
  ];

  const highlights = [
    { label: 'Students', value: '10K+' },
    { label: 'Lessons', value: '500+' },
    { label: 'Activities', value: '1000+' }
  ];

  return (
    <section id="product" className="product-modern">
      <div className="product-background-modern">
        <div className="product-gradient-modern"></div>
        <div className="product-pattern-modern"></div>
      </div>
      
      <div className="container">
        <div className="section-header-modern">
          <span className="section-label-modern">Flagship product</span>
          <h2 className="section-title-modern">Kidsphere</h2>
          <p className="section-description-modern">
            Life-skills learning for kids—delivered with the same rigor we bring to cloud, security, and automation for enterprises.
          </p>
        </div>

        <div className="product-showcase-modern">
          <div className="product-content-modern reveal-on-scroll reveal-fade-left">
            <div className="product-logo-modern">
              <img src="/kidsphere logo/logo.png" alt="Kidsphere" className="product-logo-img-modern" />
            </div>
            
            <p className="product-description-modern">
              Kidsphere is where we prove our craft in the wild: a COPPA-minded, multi-platform experience with voice-enabled activities, parent dashboards, and analytics—engineered for reliability and growth, not just demos. It complements our enterprise work in AI operations, cybersecurity, Cloud 3.0, and managed IT.
            </p>

            <div className="product-features-grid-modern">
              {features.map((feature, index) => (
                <div key={index} className="product-feature-modern reveal-on-scroll reveal-fade-up" data-delay={index * 100}>
                  <div className="feature-icon-modern">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="feature-content-modern">
                    <h4>{feature.title}</h4>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="product-stats-modern">
              {highlights.map((highlight, index) => (
                <div key={index} className="product-stat-modern">
                  <div className="stat-value-modern">{highlight.value}</div>
                  <div className="stat-label-modern">{highlight.label}</div>
                </div>
              ))}
            </div>

            <div className="product-cta-modern">
              <a 
                href="https://kidsphere.in" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-product-primary-modern"
                onClick={(e) => {
                  window.open('https://kidsphere.in', '_blank');
                }}
              >
                <span>Visit Kidsphere</span>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                  <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
              <Link 
                to="/kidsphere-detail" 
                className="btn-product-secondary-modern"
              >
                Learn More
              </Link>
            </div>
          </div>

          <div className="product-visual-modern reveal-on-scroll reveal-fade-right">
            <div className="product-image-wrapper-modern">
              <img 
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=600&fit=crop" 
                alt="Kidsphere life-skills learning platform" 
                className="product-image-modern"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/800x600/FF6B35/FFFFFF?text=Kidsphere';
                }}
              />
              <div className="product-image-glow-modern"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
